export default __webpack_public_path__ + "static/garden_design14-884cf1f1230f2d443fc1832495b7976f.webp";